// extracted by mini-css-extract-plugin
module.exports = {"container":"foodCard_container__2OwII","floatingSection":"foodCard_floatingSection__3JpyP","name":"foodCard_name__akUN4","arrow":"foodCard_arrow__1PEV_"};